import {Injectable} from '@angular/core';
import {CrudService} from "@shared/api/services/crud.service";
import {PatientRecordAppointmentNote} from "@shared/api/models/query/patient-record-appointment-note.model";
import {PatientRecordAppointmentNoteUpdate} from "@shared/api/models/command/patient-record-appointment-note.model";

@Injectable({
    providedIn: 'root'
})
export class PatientRecordAppointmentNotesService extends CrudService<
    PatientRecordAppointmentNote,
    PatientRecordAppointmentNote,
    PatientRecordAppointmentNoteUpdate,
    PatientRecordAppointmentNoteUpdate
> {

    protected override get domainEntity() {
        return 'patients'
    };

    protected override get subdomainEntity() {
        return 'record-appointment-notes';
    };
}
